const NotFound: React.FC = () => (
  <div className="text-center">
    <h1 className="text-3xl font-bold">Page Not Found</h1>
  </div>
);

export default NotFound;
